/**
 * Environment Configuration
 *
 * Provides access to runtime environment variables injected by the container.
 * These values come from deploy/legacy/chroni-care/envs/azure/values.yaml.gotmpl
 */

// Get environment configuration from runtime injection
const getEnvConfig = () => {
    return window?.process?.env || {};
};

// Export the configuration
export default getEnvConfig();
